module.exports = __webpack_public_path__ + "static/img/bg_d.78beb960.png";